(() => {
  if (customElements.get('cart-upsells-slider')) {
    return;
  }

  class CartUpsellsSlider extends HTMLElement {
    constructor() {
      super();
      // 'auto' hands slide sizing to the stylesheet, which is the only place
      // that knows how many cards there are: one card goes full width, two or
      // more go to a part-width so the next one peeks past the edge and the
      // row reads as a slider.
      //
      // There used to be a `breakpoints: { 750: { width: 300 } }` here. That
      // pinned the whole slider to 300px on any viewport over 750px, which the
      // cart drawer is — and the drawer's width does not track the viewport.
      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 16
      }
    }

    init() {
      this.sliderInstance = new Swiper(this.slider, this.options);
    }

    connectedCallback() {
      this.slider = this.querySelector('[data-slider]');
      if (!this.slider) {
        console.error('No slider el')
        return;
      }

      this.init();
    }
  }

  customElements.define('cart-upsells-slider', CartUpsellsSlider);
})();